import { useQuery } from '@tanstack/react-query';
import { getKgInsightSubscription } from '@terminal/services/alerts/event-alerts-service';

import { getKgInsightSubscriptionQueryKey } from './event-alerts-query-keys';

interface UseGetKgInsightSubscriptionArgs {
  entityTag: string;
  enabled?: boolean;
}

export const useGetKgInsightSubscription = ({
  entityTag,
  enabled = true,
}: UseGetKgInsightSubscriptionArgs) =>
  useQuery({
    queryKey: getKgInsightSubscriptionQueryKey(entityTag),
    queryFn: () => getKgInsightSubscription(entityTag),
    enabled: enabled && !!entityTag,
  });
